import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {loadStripe, Stripe, StripeCardElement, StripeElements} from "@stripe/stripe-js";
import {PaymentHttpService} from "../../../../../services/http-services/payment/payment-http.service";
import {environment} from "../../../../../../environments/environment";
import {NgIf} from "@angular/common";
import {PAGES_AND_PATHS} from "../../../../../constants/pages-and-paths";
import {Router} from "@angular/router";
import {AuthenticationHelperService} from "../../../../../services/helpers/authentication-helper.service";

@Component({
  selector: 'tl-company-payment',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './company-payment.component.html',
})
export class CompanyPaymentComponent {
  @ViewChild('cardElement') cardElement!: ElementRef;
  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  card: StripeCardElement | null = null;
  isPaymentProcessing = false;
  errorMessage = '';

  constructor(private paymentHttpService: PaymentHttpService,
              private authHelperService: AuthenticationHelperService,
              private router: Router) {}

  async ngOnInit(): Promise<void> {
    this.stripe = await loadStripe(environment.STRIPE_KEY);
    if (this.stripe) {
      this.elements = this.stripe.elements();
      this.card = this.elements.create('card', {
        hidePostalCode: true,
        style: {
          base: {
            color: '#ffffff',
            lineHeight: '50px',
            fontFamily: '"Archivo Regular, Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#808080'
            }
          },
          invalid: {
            color: '#df1b41',
            iconColor: '#df1b41'
          }
        }
      });
      this.card.mount(this.cardElement.nativeElement);
    }
  }

  async handleSubscription(): Promise<void> {
    if (!this.stripe || !this.card) {
      return;
    }
    this.isPaymentProcessing = true;
    this.errorMessage = '';
    const { paymentMethod, error } = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.card,
    });

    if (error) {
      this.errorMessage = error.message || 'Something went wrong while processing your payment. Please try again.';
      this.isPaymentProcessing = false;
      return;
    }

    if (paymentMethod) {
      this.paymentHttpService.setSubscriptionPlan({plan_id: 'tlpartner', payment_method_id: paymentMethod.id}).then(res => {
        this.isPaymentProcessing = false;
        this.authHelperService.setUserData(res.data);
        this.router.navigate([PAGES_AND_PATHS.selectTopics.pagePath]);
      }).catch (error => {
        this.errorMessage = error.message;
        this.isPaymentProcessing = false;
      });
    }
  }

}
